export default "__VITE_ASSET__DoHHiby7__"